import Table from "../component/Table1";
import moment from "moment/moment";
import React from "react";

const HistoryImmunizationRecord = ({visit}) => {

    const getData = () => {
        let r = []
        visit.immunizations.forEach(v => {
            v.record.forEach(x => {
                r.push(x)
            })
        })
        return r
    }

    const createButton = (datad) => {
        return (
            <button
                onClick={(e) => {}}
                className="btn btn-sm btn-secondary text-primary"
            >
        <span className="btn-inner--icon">
          <i className="fas fa-print"></i>
        </span>
            </button>
        );
    };

    return (
        <div className="card">
            <div
                className='card-header bg-success text-white collapsed'
                id={"heading-immm-record"}
                data-toggle='collapse'
                data-target={"#collapse-immm-record"}
                aria-expanded='false'
                aria-controls={"collapse-immm-record"}
            >
                <h4 className={'mb-0 text-white'}>Riwayat Pemeriksaan Anak</h4>
            </div>
            <div
                className='collapse'
                id={"collapse-immm-record"}
                aria-labelledby={"heading-immm-record"}>
                <div className='card-body'>
                    <Table
                        className="table table-responsive"
                        headers={[
                            "No",
                            "Menu",
                            "Tanggal",
                            "Umur Bayi",
                            "Imunisasi",
                            "BBL",
                            "PBL",
                            "Berat Badan",
                            "Suhu",
                            "Pernafasan",
                            "Status Gizi",
                            "ASI Eksklusif",
                            "Pemberian Makanan",
                            "Diagnosa",
                            "Diagnosa Kebidanan",
                            "Bidan",
                        ]}
                        data={getData()}
                        columnMapper={(datas, key) => [
                            datas.log ? (
                                <span className="btn btn-sm btn-block btn-outline-danger">
                              DELETED
                            </span>
                            ) : (
                                <>
                                    {createButton(datas.id)}
                                </>
                            ),
                            moment(datas?.field_date).format("DD-MM-YYYY"),
                            datas?.age_day + " Bulan",
                            datas?.ref_immunization?.code?.toUpperCase() +
                            " - " +
                            datas?.ref_immunization?.name,
                            datas?.immunization?.birth_weight,
                            datas?.immunization?.birth_height,
                            datas?.immunization?.visit?.examination?.weight,
                            datas?.immunization?.visit?.examination?.temperature,
                            datas?.immunization?.visit?.examination?.respiration,
                            datas.status_gizi,
                            datas.asi_exclusive,
                            <>
                                <div>{datas?.immunization?.asi}</div>
                                <div>{datas.formula}</div>
                                <div>{datas.mp_asi}</div>
                                <div>{datas.nasi}</div>
                            </>,
                            datas.immunization?.visit?.diagnoses?.map((data, i) => (
                                <div key={i}>{data.icd_code + "-" + data.icd_name}</div>
                            )),
                            datas?.immunization?.visit?.anamneses[0]?.anamnese,
                            datas?.immunization?.visit?.paramedic?.name,
                        ]}
                        issearch={false}
                        pagination={false}
                    />
                </div>
            </div>
        </div>
    )
}

export default HistoryImmunizationRecord